import React from 'react';
import DefaultLayout from './Default'
import CustomLayout from './Custom'

class Index extends React.Component {
    constructor(props) {
        super(props);
        this.state = {}
    }
    componentDidMount() {}

    render() {
        let sections = this.props.details ? this.props.details.sections : [];
        if(sections.layout == 1){
            if(! Object.keys(sections.default_layout).length) return [];
            return <article><DefaultLayout {...this.props} layout={sections.default_layout} /></article>
        }else{
            if(!(sections.custom_layout.layout).length) return [];
            return <article><CustomLayout {...this.props} sections={sections.custom_layout.layout} /></article>
        }
    }
}

export default Index;


// WEBPACK FOOTER //
// ./src/components/Journals/Details/Layouts/index.js